// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__12Vwv","title":"InfoRow_title__1KjrO"};